export const KNOWN_COUNTRIES: Record<string, string[]> = {
	us: [
		'ag',
		'ai',
		'an',
		'aq',
		'ar',
		'aw',
		'bb',
		'bl',
		'bm',
		'bo',
		'bq',
		'br',
		'bs',
		'bv',
		'bz',
		'ca',
		'cl',
		'co',
		'cr',
		'cu',
		'cw',
		'dm',
		'do',
		'ec',
		'fk',
		'fx',
		'gd',
		'gf',
		'gp',
		'gs',
		'gt',
		'gy',
		'hn',
		'ht',
		'jm',
		'kn',
		'ky',
		'lc',
		'mf',
		'mq',
		'ms',
		'mx',
		'ni',
		'pa',
		'pe',
		'pm',
		'pn',
		'pr',
		'py',
		'sr',
		'sv',
		'sx',
		'tc',
		'tt',
		'us',
		'uy',
		'vc',
		've',
		'vg',
		'vi',
		'yu',
		'zr'
	],
	eu: [
		'ad',
		'ae',
		'af',
		'al',
		'am',
		'ao',
		'at',
		'ax',
		'az',
		'ba',
		'be',
		'bf',
		'bg',
		'bh',
		'bi',
		'bj',
		'bw',
		'by',
		'cd',
		'cf',
		'cg',
		'ch',
		'ci',
		'cm',
		'cv',
		'cy',
		'cz',
		'de',
		'dj',
		'dk',
		'dz',
		'ee',
		'eg',
		'eh',
		'er',
		'es',
		'et',
		'fi',
		'fo',
		'fr',
		'ga',
		'gb',
		'ge',
		'gg',
		'gh',
		'gi',
		'gl',
		'gm',
		'gn',
		'gq',
		'gr',
		'gw',
		'hr',
		'hu',
		'ie',
		'il',
		'im',
		'iq',
		'ir',
		'is',
		'it',
		'je',
		'jo',
		'ke',
		'kg',
		'km',
		'kw',
		'kz',
		'lb',
		'li',
		'lr',
		'ls',
		'lt',
		'lu',
		'lv',
		'ly',
		'ma',
		'mc',
		'md',
		'me',
		'mg',
		'mk',
		'ml',
		'mr',
		'mt',
		'mu',
		'mw',
		'mz',
		'na',
		'ne',
		'ng',
		'nl',
		'no',
		'om',
		'pk',
		'pl',
		'ps',
		'pt',
		'qa',
		're',
		'ro',
		'rs',
		'ru',
		'rw',
		'sa',
		'sc',
		'sd',
		'se',
		'sh',
		'si',
		'sj',
		'sk',
		'sl',
		'sm',
		'sn',
		'so',
		'ss',
		'st',
		'sy',
		'sz',
		'td',
		'tf',
		'tg',
		'tj',
		'tm',
		'tn',
		'tr',
		'tz',
		'ua',
		'ug',
		'uz',
		'va',
		'ye',
		'yt',
		'za',
		'zm',
		'zw'
	],
	ap: [
		'as',
		'au',
		'bd',
		'bn',
		'bt',
		'cc',
		'ck',
		'cx',
		'fj',
		'fm',
		'gu',
		'hk',
		'hm',
		'id',
		'in',
		'io',
		'jp',
		'kh',
		'ki',
		'kp',
		'kr',
		'la',
		'lk',
		'mh',
		'mm',
		'mn',
		'mo',
		'mp',
		'mv',
		'my',
		'nc',
		'nf',
		'np',
		'nr',
		'nu',
		'nz',
		'pf',
		'pg',
		'ph',
		'pw',
		'sb',
		'sg',
		'th',
		'tk',
		'tl',
		'to',
		'tv',
		'tw',
		'vn',
		'vu',
		'wf',
		'ws'
	],
	cn: ['cn']
};
